module.exports = __webpack_public_path__ + "img/1512090867.2165c2b5.jpg";